import { App } from '@config/site/app'
import { Feature } from '@config/site/app/features'

export const FeaturesEnabled: Partial<Record<App, Feature[]>> = {
  [App.STAR]: [Feature.EXPORT, Feature.FAVORITES],
  [App.MUSIC]: [],
}
